export class BaseWalletFactory extends Array {
    constructor(accountProvider, storage) {
        super();
        this._accountProvider = accountProvider;
        this._storage = storage;
    }
}
export class BaseWallet extends BaseWalletFactory {
}
export var LoginStatusEnum;
(function (LoginStatusEnum) {
    LoginStatusEnum["INIT"] = "INIT";
    LoginStatusEnum["SUCCESS"] = "SUCCESS";
    LoginStatusEnum["FAIL"] = "FAIL";
})(LoginStatusEnum || (LoginStatusEnum = {}));
